export default {
    crop: {
        title: "afgrøde",
        cropSize: "Grødstørrelse",
        zoom: "Zoom",
        custom: 'Brugerdefineret',
        post: 'Indlæg',
        square: 'Kvadrat',
        landscape: 'Landskab',
        story: 'Historie',
        portrait: 'Portræt',
        carousel: 'Karrusel',
        commonAspectRatio: 'Almindeligt billedformat',
    },
};
